import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import "./index.scss";
import { CircularProgress } from "@mui/material";

const Loader = () => {
  const { promiseInProgress } = usePromiseTracker();
  return (
    promiseInProgress && (
      <div className="loading-indicator">
        <div className="spinner-container ">
          <span className="loader"></span>
        </div>
      </div>
    )
  );
};

export default Loader;
